<template>
    <button class="mg-btn-gold" color="primary" text-color="whiteprimary"  v-on:click="modalOpen">Add Label</button>    
    <button type="button" class="d-none" data-bs-toggle="modal" data-bs-target="#labelModals" id="addLabelBtn"> </button>             
    <div class="modal fade right" id="labelModals" tabindex="-1" style="display: none;" aria-hidden="true"  data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="staticBackdropLabel">
        <div class="modal-dialog modal-dialog-centered">            
            <div class="modal-content">
                <div class="modal-header">
                    <input type="hidden" name="labelEditId" id="labelEditId">
                    <h5 class="modal-title">{{ modalType }} Label</h5> 
                    <button type="button" class="btn-close" id="closePop" data-bs-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <form @submit.prevent="onSubmit" class="labelFrm" id="labelFrm">
                    <div class="modal-body setformbackform">
                        <div class="row">
                            <div class="col-sm-12">
                                <span v-if="errorMessage != ''">
                                    <p class="alert alert-danger error-msg" >{{ errorMessage }}</p>
                                </span>
                            </div>
                        </div> 
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="labelName" class="form-label">Label Name<span class="requiredCls">*</span></label> 
                                    <input type="text" class="form-control" name="labelName" id="labelName" placeholder="Enter label name"  v-model="v$.form.labelName.$model"> 
                                    <div class="input-errors" v-for="(error, index) of v$.form.labelName.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="formmginput-controlx mb-2"> 
                                    <label for="labelColor" class="form-label">Label Class<span class="requiredCls">*</span></label> 
                                    <input type="text" class="form-control" name="labelColor" id="labelColor" placeholder="Enter label color"  v-model="v$.form.labelColor.$model"> 
                                    <div class="input-errors" v-for="(error, index) of v$.form.labelColor.$errors" :key="index">
                                        <div class="error-msg">{{ error.$message }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div class="modal-footer">                           
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-on:click="addLabel" v-if="formLoader === 1">{{ buttonName }}</button>
                        <button type="button" class="mg-btn-gold" id="saveUpdateBtn" :disabled="v$.form.$invalid" v-else><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Loading...</button>
                    </div>
                
                </form>
            </div>
        </div>
    </div>

</template>
<script>
import useVuelidate from '@vuelidate/core'
import {
    required,
    // maxLength,
    minLength
} from '@vuelidate/validators'
import $ from "jquery";
import axios from 'axios'
export default {
    name: 'AddEditLabels',
    emits: ['reloadTableData'], 
    data() {
        return {
            img_url: process.env.VUE_APP_IMG_URL,
            modalType: 'Add',
            buttonName: 'Save',
            errorMessage: '',
            formLoader: 1,
            logoFile: null,
            form: {
                labelName: '',
                labelColor: '',
            },
        }
    },
    methods: {
        async modalOpen() {
            this.errorMessage = ''
            this.form.labelName = '';
            this.form.labelColor = '';
            
            this.modalType = 'Add';
            this.buttonName = 'Save',
            this.logoFile = null,
            this.v$.$reset()
            document.getElementById('labelEditId').value = '';
            document.getElementById('addLabelBtn').click();
            setTimeout(async () =>
                $("#labelName").focus(),
            500);
        },
        async addLabel() {
            this.formLoader = 2
            let _post = {}
            let _URL = ''
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            var labelName = $('#labelName').val();
            var labelColor = $('#labelColor').val();
            if (this.modalType == 'Edit') {
                _URL = process.env.VUE_APP_API_URL + 'label/update'
                var label_id = $('#labelEditId').val();
                _post = {
                    label_id: label_id,
                    label: labelName,
                    color_code: labelColor,
                }
            } else {
                _URL = process.env.VUE_APP_API_URL + 'label/create'
                _post = {
                    label: labelName,
                    color_code: labelColor,
                }
            }
            await axios.post(_URL, _post)
                .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('closePop').click();
                    this.$toast.success(resp.data.message);
                    this.$store.state.labels.loadLabelsData = 1
                    this.$emit('reload-table-data');
                } else if (resp.status == 200 && resp.data.status == 'failure') {
                    this.errorMessage = resp.data.message;
                }
                    this.formLoader = 1
            })
                .catch(error => {
                this.errorMessage = error.message;
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
                this.errorRes = error.response.data.message;
                this.formLoader = 1
            })            
        },
        async modalEditOpen() {
            let label_id = $('.labelValId').val();
            $('.loadimg').show();
            this.errorMessage = ''
            this.form.labelName = '';
            this.form.labelColor = '';
            this.modalType = 'Edit',
            this.buttonName = 'Update',
            document.getElementById('labelName').value = '';
            document.getElementById('labelColor').value = '';
            this.v$.$reset()
            this.formLoader = 2
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
            await axios.post(process.env.VUE_APP_API_URL + 'label/get', {
                label_id: label_id
            })
            .then((resp) => {
                if (resp.status == 200 && resp.data.status == 'success') {
                    document.getElementById('labelName').value = resp.data.data.label;
                    document.getElementById('labelColor').value = resp.data.data.color_code;
                    document.getElementById('labelEditId').value = resp.data.data._id;
                    this.v$.form.labelName.$model = resp.data.data.label;
                    this.v$.form.labelColor.$model = resp.data.data.color_code;
                    document.getElementById('addLabelBtn').click();
                    this.v$.$reset()
                    $('.loadimg').hide();
                    setTimeout(async () =>
                        $("#labelName").focus(),
                    500);
                }
                this.formLoader = 1
            })
            .catch(error => {
                // this.errorMessage = error.message;
                console.error("There was an error!", error);
                console.log("response", error.response.status);
                console.log("message", error.response.data.message);
                this.formLoader = 1
                // this.errorRes = error.response.data.message;
            })
        },
    },
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    validations() {
        return {
            form: {
                labelName: {
                    required,
                    min: minLength(2)
                },
                labelColor: {
                    required
                },
            },
        }
    },
}
</script>